import { Container, Title, Button, TipsBar } from '@/components'

import { Swiper, SwiperSlide } from 'swiper/react'

import { INFLUENCERS } from './constants'

import useInfluencers from './hooks'
import styles from './styles.module.scss'
import Image from 'next/image'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const Influencers = ({ tipsBar = true, customClass, bgImage }) => {
  const { onClickItem } = useClickWithScroll()

  const { settings } = useInfluencers()

  const backgroundImage = {
    backgroundImage: `url(${bgImage?.src})`
  }

  return (
    <>
      {tipsBar && (
        <TipsBar
          text={'PLANEJADO PARA TODOS OS NÍVEIS • TREINE NO SEU RITMO'}
        />
      )}
      <section
        className={`fgt-section ${styles.influencers} ${customClass}`}
        style={backgroundImage}
      >
        <Container>
          <Title Tag="h2" alignText="center" colorText="light">
            Faça os treinos das <span>influencers</span>
          </Title>
          <p className={`fgt-subtitle fgt-subtitle--light`}>
            Confira alguns influencers que confiam no método da
            <strong>
              <i> Academia Foguete.</i>
            </strong>
          </p>

          <Swiper {...settings} className="fgt-swiper">
            {INFLUENCERS.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={styles.influencers__item}>
                    <Image
                      src={item.imageUrl}
                      alt={item.alt}
                      width={218}
                      height={183}
                    />
                    <div className={styles.influencers__instagram}>
                      {item.instagram}
                    </div>
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>

          <div className="fgt-section__action">
            <Button
              id="btn-section-influencers"
              variant="primary"
              className={'fgt-section__action--button'}
              onClick={() => {
                onClickItem('comparePlans', 0)
              }}
            >
              QUERO TREINAR COM AS INFLUENCERS
            </Button>
          </div>
        </Container>
      </section>
    </>
  )
}

export default Influencers
